import moment from 'moment';

export const numberValueFormatter = (cell) => (cell.value ? cell.value.toLocaleString() : 0);
export const percentValueFormatter = (cell) => `${cell.value ? cell.value.toLocaleString() : 0} %`;
export const dateValueFormatter = (cell) => (cell.value ? moment(cell.value).format('DD.MM.YYYY') : undefined);
